/**
 * A property decorator to be used on base editor properties
 *
 * @param token
 */

// AOT build requires decorator to be a non-arrow function
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function lazyInject(token: any): PropertyDecorator {
  return (target: object, propertyKey: string | symbol): void => {
    Object.defineProperty(target, propertyKey, {
      configurable: true,
      get(): any {
        // on the very first access to property
        // redefine the property of the instance to have a regular resolved value
        // then, prototype getter will never be called again
        // eslint-disable-next-line no-invalid-this
        Object.defineProperty(this, propertyKey, {
          // eslint-disable-next-line no-invalid-this
          value: this.inject(token),
        });

        // eslint-disable-next-line no-invalid-this
        return this[propertyKey];
      },
    });
  };
}
